import './App.css';

function App() {
  return (
    <div style={{ width: '100vw', height: '100vh', margin: 0 }}>
      {/* <iframe title="Entriks Anruferliste" width="100%" height="100%" src="https://app.powerbi.com/reportEmbed?reportId=82ecc6c4-e419-482e-9778-ee1c5c082def&autoAuth=true&ctid=a1f1f95c-4c0a-4b28-a769-d67d1ebd762e" frameborder="0" allowFullScreen="true"></iframe> */}
   <iframe title="Entriks Anruferliste" width="100%" height="100%" src="https://app.powerbi.com/reportEmbed?reportId=fc47da4c-29fe-4b96-a57a-b64586de0acd&autoAuth=true&ctid=a1f1f95c-4c0a-4b28-a769-d67d1ebd762e" frameborder="0" allowFullScreen="true"></iframe>
    </div>
  );
}

export default App;
